<template>
  <gmap-autocomplete :options="options" :value="value" :placeholder="placeholder || ''" class="gmaps-autocomplete" @place_changed="setPlace" />
</template>

<script>
  export default {
    props: {
      placeholder: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: '',
      },
      options: {
        type: Object, 
        default: function () {
          return {
            
          }
        }
      }
    },
    methods: {
      setPlace: function (payload) {
        let location = payload.geometry.location;

        let addresses = {};
        addresses.formatted_address = payload.formatted_address;
        payload.address_components.forEach(x => {
          addresses[x.types[0]] = x.short_name;
        });
        this.$emit('address-components', addresses);

        this.$emit('coordinates', {
          lng: location.lng(),
          lat: location.lat()
        });
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>